<app-simple-responsive-frame>
    <div class="document-container" [class.loading]="loading">
        <h2>Agrega los papeles de tu {{ segmentName?.toLowerCase() }}.</h2>

        <p class="description">
            Para poder publicar tu propiedad, debes informar sobre el estatus de los papeles. Estos documentos no serán
            públicos, solo los ves tú.
            <br /> Usa formato PDF. Máximo 10 MB por documento.
        </p>

        <!-- Grid de bloques -->
        <div class="document-grid" *ngIf="!loading; else skeleton">
            <div class="document-item" *ngFor="let document of documents; trackBy: trackByPaper">
                <h5>{{ document.label }}</h5>

                <p-dropdown
                    [options]="document.statusOptions"
                    [(ngModel)]="document.selectedStatus"
                    optionLabel="optionName"
                    placeholder="Selecciona una opción"
                    [showClear]="true"
                    (onChange)="onStatusChanged(document)"
                    ariaLabel="Estado del documento {{document.label}}">
                </p-dropdown>

                <!-- Dropzone -->
                <p-card styleClass="dropzone-card">
                    <div class="dropzone" [class.disabled]="!document.selectedStatus">
                        <i class="pi pi-file dropzone-icon" aria-hidden="true"></i>
                        <span class="dropzone-title">Arrastra tus documentos aquí</span>
                        <span class="dropzone-subtitle">Seleccionar documentos</span>

                        <p-fileUpload
                            #uploader
                            mode="basic"
                            name="documentUpload"
                            [auto]="true"
                            [multiple]="true"
                            [customUpload]="true"
                            accept="application/pdf,.pdf"
                            [maxFileSize]="10 * 1024 * 1024"
                            [disabled]="!document.selectedStatus"
                            [showCancelButton]="false"
                            [showUploadButton]="false"
                            (uploadHandler)="onUpload($event, document, uploader)"
                            (onBeforeUpload)="onBeforeUpload(document)"
                            (onSelect)="onSelectValidate($event)">
                        </p-fileUpload>
                    </div>
                </p-card>

                <!-- Lista de archivos subidos -->
                <div class="uploaded-files" *ngIf="document.files?.length">
                    <h6>Archivos cargados</h6>
                    <ul>
                        <li class="file-row" *ngFor="let file of document.files; trackBy: trackByFile">
                            <a [href]="file.url" target="_blank" rel="noopener">
                                <i class="pi pi-file-pdf" aria-hidden="true"></i> {{ file.name }}
                            </a>
                            <span class="meta" *ngIf="file.size">• {{ file.size | number }} bytes</span>

                            <button type="button" class="icon-btn" pButton (click)="confirmDelete(file, document)"
                                    [attr.aria-label]="'Eliminar ' + file.name">
                                <i class="pi pi-trash"></i>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- Skeleton -->
        <ng-template #skeleton>
            <div class="skeleton-grid">
                <p-skeleton *ngFor="let i of [0,1,2,3]" width="100%" height="200px"></p-skeleton>
            </div>
        </ng-template>

        <div class="tips">
            <span><b>Tips para subir tus papeles</b></span>
        </div>

        <!-- Poder notariado -->
        <div class="power-of-attorney">
            <p-checkbox
                [(ngModel)]="isPowerSelected"
                [binary]="true"
                (ngModelChange)="onPowerSelectionChange()"
                label="No soy el propietario, tengo un poder de exclusividad.">
            </p-checkbox>

            <div *ngIf="isPowerSelected" class="power-upload">
                <h5>Poder notariado</h5>
                <p-card styleClass="dropzone-card">
                    <div class="dropzone">
                        <i class="pi pi-file dropzone-icon" aria-hidden="true"></i>
                        <span class="dropzone-title">Arrastra tus documentos aquí</span>
                        <span class="dropzone-subtitle">Seleccionar documento</span>

                        <p-fileUpload
                            #powerUploader
                            mode="basic"
                            name="powerUpload"
                            [auto]="true"
                            [multiple]="true"
                            [customUpload]="true"
                            accept="application/pdf,.pdf"
                            [maxFileSize]="10 * 1024 * 1024"
                            [showCancelButton]="false"
                            [showUploadButton]="false"
                            (uploadHandler)="onUpload($event, powerDocument, powerUploader)"
                            (onSelect)="onSelectValidate($event)">
                        </p-fileUpload>
                    </div>
                </p-card>

                <!-- Lista de archivos del poder -->
                <div class="uploaded-files" *ngIf="powerDocument.files?.length">
                    <h6>Archivos cargados</h6>
                    <ul>
                        <li class="file-row" *ngFor="let file of powerDocument.files; trackBy: trackByFile">
                            <a [href]="file.url" target="_blank" rel="noopener">
                                <i class="pi pi-file-pdf" aria-hidden="true"></i> {{ file.name }}
                            </a>
                            <span class="meta" *ngIf="file.size">• {{ file.size | number }} bytes</span>

                            <button type="button" class="icon-btn" pButton (click)="confirmDelete(file, powerDocument)"
                                    [attr.aria-label]="'Eliminar ' + file.name">
                                <i class="pi pi-trash"></i>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <!-- Barra de navegación -->
    <app-page-navigation-bar
        [value]="35"
        [type]="'complete'"
        [previousPageURL]="previousUrl"
        [nextPageURL]="nextUrl"
        [flowMode]="currentMode"
        [stepKey]="'papers'"
        (goNext)="handleNextStep()"
        (goPrevious)="handlePreviousStep()"
        (saveAndExit)="handleSaveAndExit()">
    </app-page-navigation-bar>
</app-simple-responsive-frame>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
